import { render, staticRenderFns } from "./ModalVinculacaoGO.vue?vue&type=template&id=e62e84b4&lang=pug"
import script from "./ModalVinculacaoGO.vue?vue&type=script&lang=js"
export * from "./ModalVinculacaoGO.vue?vue&type=script&lang=js"
import style0 from "./ModalVinculacaoGO.vue?vue&type=style&index=0&id=e62e84b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports